import {
  DOWNLOAD_SURGE_LOGS,
  DOWNLOAD_SURGE_LOGS_SUCCESS,
  DOWNLOAD_SURGE_LOGS_ERROR,
  DOWNLOAD_SURGE_LOGS_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadSurgeLogs = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_SURGE_LOGS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_SURGE_LOGS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_SURGE_LOGS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_SURGE_LOGS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadSurgeLogs;
